
import React from 'react';
import { TextLink } from "@vds/buttons";
import { Title, Body } from "@vds/typography";
import styled from 'styled-components';
import { ListItem } from "@vds/lists";

const PaddingZero = styled.div`
padding-bottom:16px;

`;
const CoverageLink = styled(TextLink)`
color: blue;
`;

const StyledPaddingDiv = styled.div`
padding-top:24px;

`
const StyledPaddingDiv2 = styled.div`
padding-top:30px;
`
const StyledPadding = styled.div`
padding-top:30px;
padding-bottom:16px;
`
const StyledPaddingDiv3 = styled.div`
padding-top:20px;


`
const PaddingZero1 = styled(ListItem)`
padding-top:0px;
`



const DeviceSpecific = ({ deviceSpecific }) => {

    let deviceSpecificPostPaid = deviceSpecific?.postpaid;

    let deviceSpecificPostPaidContentSmart = deviceSpecificPostPaid?.smartPhones?.supportedOperatingSystems;
    let deviceSpecificPostPaidContentBasic = deviceSpecificPostPaid?.basicPhones?.supportedPhones;
    let deviceSpecificPostPaidContentTablets = deviceSpecificPostPaid?.tablets?.supportedTablets;
    let deviceSpecificReminderContent = {}

    const displayDeviceContent = (deviceSpecificPostPaidContent) => { 
        return(
            <div>
                    {deviceSpecificPostPaidContent?.map((it, inde) => (
                        it?.brandDevices?.map((ite, ind) => (
                        <>
                        <StyledPadding>
                    <Title size="small" bold>{ite?.deviceName} </Title></StyledPadding>
                        {ite?.deviceDetails?.categoryContent[0]?.content?.map((item, index) => (
                        <React.Fragment>
                            
                            <Title size="small">
                                {item &&
                                    <span dangerouslySetInnerHTML={{ __html: item.header }} />}
                            </Title>
                            <PaddingZero></PaddingZero>
                            {item.header === 'Device Settings' ?
                                <>
                                    {item && item.value && item.value.map((ele, index) => (
                                        <StyledPaddingDiv3>
                                            <Body size="medium"> <span dangerouslySetInnerHTML={{ __html: ele.key }} /></Body>

                                        </StyledPaddingDiv3>
                                        
                                    ))}
                                    

                                </>
                                :
                                <>
                                    {item && item.value && item.value.map((ele, index) => (

                                        <PaddingZero1
                                            size="bodyLarge"
                                            viewport="desktop"
                                            surface="light"
                                        >
                                            <Body size="medium"> <span dangerouslySetInnerHTML={{ __html: ele.key }} /></Body>

                                        </PaddingZero1>
                                    ))}
                                </>}
                                <PaddingZero></PaddingZero>
                        
                        </React.Fragment>))
                        }
                    <Body size="medium"> {deviceSpecificPostPaid?.coverageMapText}
                            <CoverageLink color="blue"
                                data-clickstream=" Device Emulator"
                                data-track=" Device Emulator"
                                data-analyticsTrack=" Device Emulator"
                                data-testid="deviceEmulatorId" bold="false" onClick={e => window.open(ite?.coverageMapLink)}> {ite?.coverageMapTextLink}</CoverageLink></Body> 
                        </>))
                        ))}
                </div>
        )
    }

    //devicereminder
    deviceSpecificReminderContent = deviceSpecificPostPaid?.smartPhones?.deviceReminders?.categoryContent[0]?.content

    return (
        <React.Fragment>
            <>
                {deviceSpecificPostPaidContentSmart?.length>0 && displayDeviceContent(deviceSpecificPostPaidContentSmart) }
                {deviceSpecificPostPaidContentBasic?.length>0 && displayDeviceContent(deviceSpecificPostPaidContentBasic) }
                {deviceSpecificPostPaidContentTablets?.length>0 && displayDeviceContent(deviceSpecificPostPaidContentTablets) }
                
                <div>
                    {deviceSpecificReminderContent && deviceSpecificReminderContent.map((item, index) => (
                        <React.Fragment>
                            <StyledPaddingDiv></StyledPaddingDiv>
                            <Title size="small">
                                {item &&
                                    <span dangerouslySetInnerHTML={{ __html: item.header }} />}
                            </Title>
                            {item && item.value && item.value.map((ele, index) => (
                                <ListItem
                                    size="bodyLarge"
                                    viewport="desktop"
                                    surface="light"
                                >
                                    <Body size="medium"> <span dangerouslySetInnerHTML={{ __html: ele.key }} /></Body>
                                </ListItem>
                            ))}
                        </React.Fragment>))}
                </div></>
        </React.Fragment>)
}


export default DeviceSpecific;